import domReady from '@wordpress/dom-ready';

domReady(() => {
	const megaMenu = document.querySelector('.mega-menu');
	const header = document.querySelector('.l-header');
	const mainMenu = document.querySelector('.l-header__menu');
  const megaMenuButtonToggles = document.querySelectorAll('.mega-menu .wp-block-navigation__container > .wp-block-navigation-item.has-child > .wp-block-navigation-submenu__toggle');
  const megaMenuSubmenus = document.querySelectorAll('.mega-menu .l-header__menu-heading .wp-block-navigation-submenu__toggle');

	if (megaMenu) {
		const headerHeight =
			megaMenu.parentElement.getBoundingClientRect().top +
			megaMenu.parentElement.getBoundingClientRect().height;
		document.documentElement.style.setProperty(
			'--mega-menu-header-height',
			`${headerHeight}px`
		);

    megaMenuButtonToggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        header.classList.toggle('has-open-submenu');

        megaMenuSubmenus.forEach((submenu) => {
          submenu.setAttribute('aria-expanded', true);
        });
      });
    });

    document.addEventListener('click', (e) => {
      if (!megaMenu.contains(e.target)) {
        header.classList.remove('has-open-submenu');
      }
	  });
  }
});
